// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoPlaylist_video__P2stJ","content":"VideoPlaylist_content__m8_fD"};